import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Skeleton from 'react-loading-skeleton';
import { FaCircleCheck } from "react-icons/fa6";

const ViewVendorDetails = () => {
    const { id } = useParams()
    const [loading, setLoading] = useState(true);
    const [vendorDetails, setVendorDetails] = useState({
        id: "",
        name: "",
        verified: false,
        phone: "",
        email: "",
        location: "",
        pincode: "",
        services: [],
        previousWorkImages: []
    });
    const [previewImage, setPreviewImage] = useState(null);
    const navigate = useNavigate();
    const { vendorId } = useParams();
    console.log(vendorDetails);
    

    const handleBackClick = () => {
        navigate(-1);
    };

    const handleImageClick = (imageUrl) => {
        setPreviewImage(imageUrl);
    };

    const closePreview = () => {
        setPreviewImage(null);
    };

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/vendor/${id}`)
            .then(response => {
                const data = response.data.data;
                console.log('====================================');
                console.log("DaTA",data);
                console.log('====================================');
                const serviceNames = data?.services?.map(service => service.name);

                const transformedData = {
                    id: `VD-${data.vendor.address_id}`,
                    name: data.vendor.name,
                    verified: data.vendor.is_verified === 1,
                    phone: data.vendor.phone ? `+91 ${data.vendor.phone}` : "",
                    email: data.vendor.email,
                    location: [
                        data.vendor.address?.district,
                        data.vendor.address?.city,
                        data.vendor.address?.state,
                        data.vendor.address?.country
                    ].filter(Boolean).join(", "),
                    pincode: (() => {
                        const raw = data.vendor?.address?.postal_codes;
                        try {
                            const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
                            return Array.isArray(parsed) ? parsed.join(", ") : "N/A";
                        } catch {
                            return "N/A";
                        }
                    })(),
                    services: serviceNames,
                    previousWorkImages: data?.vendor?.portfolio?.map(item => item.path) || []
                };

                setVendorDetails(transformedData);
                setLoading(false);
            })
            .catch(error => {
                toast.error("Error fetching vendor details");
                setLoading(false); // ✅ Even on error, stop loading to avoid infinite spinner
            });
    }, [vendorId]);

    if (!vendorDetails) {
        return (
            <div className="p-5">
                <Skeleton count={5} height={30} />
            </div>
        );
    }

    if (loading) {
        return (
            <div className="flex justify-center items-center h-64">
                <div className="spinner"></div>
            </div>
        );
    }

    return (
        <React.Fragment>
            {loading && (
                <div className="loader-overlay">
                    <div className="loader"></div>
                </div>
            )}
            {!loading && previewImage && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
                    onClick={closePreview}
                >
                    <img
                        src={previewImage}
                        alt="Preview"
                        className="max-w-[90%] max-h-[90%] rounded-lg border"
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>
            )}
            {!loading && (
                <figure className='border shadow-lg'>
                    <div className='px-5 py-4 space-y-1 border-b' style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
                        <span>
                            <h1 className='text-base font-medium'>Vendor Details</h1>
                            <p className='text-xs text-gray-500'>Check your booked vendor details</p>
                        </span>
                        <button
                            onClick={handleBackClick}
                            className="px-4 py-1 rounded-md hover:bg-blue-700" style={{ backgroundColor: "black", color: "white" }}
                        >
                            Back
                        </button>
                    </div>
                    <div className='p-5'>
                        <div className=''>
                            <div className='space-y-3 w-100'>
                                <div>
                                    <table className='text-sm font-medium'>
                                        <tbody>
                                            <tr>
                                                <td className='text-gray-500 pr-3 pb-3 align-top w-40'>Vendor Id</td>
                                                <td className='pb-2'>{vendorDetails?.id}</td>
                                            </tr>
                                            <tr>
                                                <td className='text-gray-500 pr-3 pb-3 align-top w-40'>Name</td>
                                                <td className='pb-2'>{vendorDetails?.name}</td>
                                            </tr>
                                            <tr>
                                                <td className='text-gray-500 pr-3 pb-3 align-top w-40'>Verified Status</td>
                                                {/* <td className='pb-2 capitalize flex items-center'>
                                                    {vendorDetails?.veris_verified === 1  && (
                                                        <FaCircleCheck className='fill-green-500 mt-[2.5px] mr-1' />
                                                    )}
                                                    {vendorDetails?.verified ? "Verified" : "Not Verified"}
                                                </td> */}
                                                <td className="pb-2 capitalize flex items-center">
                                                    {vendorDetails?.verified && (
                                                        <FaCircleCheck className="fill-green-500 mt-[2.5px] mr-1" />
                                                    )}
                                                    {vendorDetails?.verified ? "Verified" : "Not Verified"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='text-gray-500 pr-3 pb-3 align-top w-40'>Phone</td>
                                                <td className='pb-2'>{vendorDetails?.phone}</td>
                                            </tr>
                                            <tr>
                                                <td className='text-gray-500 pr-3 pb-3 align-top w-40'>Email Address</td>
                                                <td className='pb-2'>{vendorDetails?.email}</td>
                                            </tr>
                                            <tr>
                                                <td className='text-gray-500 pr-3 pb-3 align-top w-40'>Location</td>
                                                <td className='pb-2'>{vendorDetails?.location}</td>
                                            </tr>
                                            <tr>
                                                <td className='text-gray-500 pr-3 pb-3 align-top w-40'>Pincode</td>
                                                <td className='pb-2'>{vendorDetails?.pincode}</td>
                                            </tr>
                                            <tr style={{ alignItems: "flex-start" }}>
                                                <td className='text-gray-500 pr-3 pb-3 flex align-top w-40'>Services Offered</td>
                                                <td className='pb-2'>
                                                    <span>{vendorDetails?.services.join(', ')}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='text-gray-500 pr-3 pb-3 align-top w-40'>Previous Work Images</td>
                                                <td className='pb-2'>
                                                    <div className="grid grid-cols-3 gap-2">
                                                        {vendorDetails.previousWorkImages.map((image, index) => (
                                                            <img
                                                                key={index}
                                                                src={`${process.env.REACT_APP_STORAGE_BASE_URL / image}`}
                                                                alt={`Work ${index + 1}`}
                                                                className="w-24 h-24 object-cover cursor-pointer rounded"
                                                                onClick={() => handleImageClick(image)}
                                                            />
                                                        ))}
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </figure>
            )}
        </React.Fragment>
    );
};

export default ViewVendorDetails;
